import React from 'react';
import Footer from '../Footer/Footer';
import Header from '../Header/Header';
import About from './components/About';
import Banner from './components/Banner';
import BrandSlide from './components/BrandSlide';
import Delivery from './components/Delivery';
import Services from './components/Services';
import Testimonials from './components/Testimonials';

const Home = () => {
    return (
        <div>
            <Header />
            <Banner />
            <Services />
            <Delivery />
            <About />
            <Testimonials />
            <BrandSlide />
            <Footer />
        </div>
    );
};

export default Home;